module.exports = __webpack_public_path__ + "static/media/bg.40f54d31.svg";